import { Fragment, useContext } from 'react';

import { DataSourceBadge } from '../ComponentForm/DataSource/DataSourceBadge/DataSourceBadge';
import { EndpointParamsList } from '../ComponentForm/DataSource/EndpointParamsList/EndpointParamsList';
import { PageContext } from '../../contexts/PageContext';

import type { ComponentResponse } from '../../types';

import styles from './ComponentBadges.module.scss';

type Props = {
  component: ComponentResponse;
  small?: boolean;
};

function ComponentBadges({ component, small }: Props) {
  const data = component?.data;
  const dataSource = data?.source;
  const dataType = data?.type;
  const endpoint = dataSource?.endpoint;
  const hasPreset = Boolean(data?.preset2?.length);
  const usePageTaxonomy = component?.options?.usePageTaxonomy;
  const { page } = useContext(PageContext);

  let params: Record<string, string> = dataSource?.params
    ? (dataSource.params as Record<string, string>)
    : {};

  if (component.type === 'filtered-list') {
    params = {};

    const usePageCategory =
      usePageTaxonomy &&
      (!page ||
        page.type === 'category' ||
        (page.type === 'template' && page.forType === 'category'));

    if (component.categoryId || usePageCategory) {
      params.categoryId = usePageCategory
        ? 'from page'
        : String(component.categoryId);
    }

    if (component.filters && component.filters.length > 0) {
      params.filters = '«preset»';
    }
  }

  return (
    <div className={styles.componentBadges}>
      {component.data && (
        <Fragment>
          <DataSourceBadge
            dataType={dataType}
            endpoint={endpoint}
            hasPreset={hasPreset}
            small={small}
          />
          {dataSource && !hasPreset && (
            <EndpointParamsList
              params={params}
              className={styles.paramsBadges}
              small={small}
            />
          )}
          {dataType === 'seasons' && (
            <EndpointParamsList
              params={
                component.categoryId !== undefined
                  ? { categoryId: component.categoryId }
                  : {}
              }
              className={styles.paramsBadges}
              small={small}
            />
          )}
        </Fragment>
      )}
      {component.type === 'filtered-list' && (
        <EndpointParamsList
          params={params}
          className={styles.paramsBadges}
          small={small}
        />
      )}
    </div>
  );
}

export { ComponentBadges };
